import { DETAILS_FETCH_REQUEST, DETAILS_FETCH_SUCCESS, DETAILS_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchDetailsRequest = () => {
    return {
        type: DETAILS_FETCH_REQUEST
    }
}

const fetchDetailsSuccess = data => {
    return {
        type: DETAILS_FETCH_SUCCESS,
        payload: data,
    }
}

const fetchDetailsFailure = error => {
    return {
        type: DETAILS_FETCH_FAILURE,
        payload: error,
    }
}


export const getDetails = slug => {
    return (dispatch) => {
        dispatch(fetchDetailsRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/details/${slug}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then((response) => {
                dispatch(fetchDetailsSuccess(response));
            })
            .catch((error) => {
                dispatch(fetchDetailsFailure(error.message));
            })
    }
}